import { render } from "./promotionLogin.vue?vue&type=template&id=0783bab7&scoped=true"
import script from "./promotionLogin.vue?vue&type=script&lang=js"
export * from "./promotionLogin.vue?vue&type=script&lang=js"

import "./promotionLogin.vue?vue&type=style&index=0&id=0783bab7&scoped=true&lang=scss"

import exportComponent from "D:\\project\\pc\\website\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0783bab7"]])

export default __exports__